import DOMAIN from 'constants/domains'
import React from 'react'
import { getDomain , getKsClientLowerCase, isSaficDomain} from 'utils/domain'

import Icon, { IconProps } from './Icon'

/**
 * スタッフ決定アイコン
 */
const StaffAssignedIcon: React.FC<IconProps> = (props) => {
  const domain = getKsClientLowerCase() !== undefined ? getKsClientLowerCase() : isSaficDomain() ? 'safic' : {
    [DOMAIN.SJ]: 'sj',
  }[getDomain()]

  const human =
    domain === 'safic'
      ? 'var(--color-text-for-main-background)'
      : 'var(--color-text)'

  const check =
    domain === 'safic'
      ? 'var(--color-text-for-main-background)'
      : 'var(--color-main)'

  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="120"
        height="120"
        viewBox="0 0 100 100"
      >
        <g transform="translate(-3)">
          <path
            d="M47.368,84.211H0V73.685c0-3.283,1.549-6.377,4.6-9.2a36.475,36.475,0,0,1,11.18-6.581A76.325,76.325,0,0,1,29.6,53.953,69.52,69.52,0,0,1,42.1,52.632a48.788,48.788,0,0,1,5.263.316L31.579,68.422,47.366,84.209ZM42.1,42.106A21.031,21.031,0,0,1,21.053,21.053a21.187,21.187,0,0,1,.55-4.8H62.608a21.183,21.183,0,0,1,.55,4.8A21.031,21.031,0,0,1,42.1,42.106ZM61.349,12.5H22.861a21.061,21.061,0,0,1,38.488,0Z"
            transform="translate(3 4)"
            fill={human}
          />
          <path
            d="M30.263,54.605,12,36.184l7.368-7.421L30.263,39.711l27-27.211,7.368,7.421Z"
            transform="translate(38.368 36.237)"
            fill={check}
          />
          <rect
            width="30"
            height="3.75"
            rx="1.875"
            transform="translate(14.25 12.75)"
            fill={human}
          />
        </g>
      </svg>
    </Icon>
  )
}

export default StaffAssignedIcon
